import React from 'react'
import { X } from 'lucide-react'
import { Button } from '../../ui/button'
import { Card, CardContent, CardHeader, CardTitle } from '../../ui/card'

interface SurveyTipsModalProps {
  onClose: () => void
}

export function SurveyTipsModal({ onClose }: SurveyTipsModalProps) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <Card className="w-full max-w-2xl m-4">
        <CardHeader className="flex flex-row items-center justify-between">
          <CardTitle>Survey Tips</CardTitle>
          <Button
            variant="ghost"
            size="icon"
            onClick={onClose}
            className="h-8 w-8"
          >
            <X className="h-4 w-4" />
          </Button>
        </CardHeader>
        <CardContent className="space-y-6">
          <div className="space-y-2">
            <h3 className="font-medium text-sm">General Guidelines</h3>
            <ul className="list-disc pl-6 space-y-2 text-muted-foreground text-sm">
              <li>Answer based on your organisation's actual tendencies, not what you wish they were</li>
              <li>Consider the organisation as a whole, not just your team or department</li>
            </ul>
          </div>

          <div className="space-y-2">
            <h3 className="font-medium">Section-Specific Tips</h3>
            <div className="space-y-2">
              <div>
                <h4 className="font-medium text-sm">Approach to Leadership</h4>
                <p className="text-sm text-muted-foreground">
                  Rate your agreement with statements about your organisation’s leadership.
                </p>
              </div>
              <div>
                <h4 className="font-medium text-sm">Current Focus</h4>
                <p className="text-sm text-muted-foreground">
                  Indicate where your organisation currently sits on each spectrum (1-9 scale).
                </p>
              </div>
              <div>
                <h4 className="font-medium text-sm">Aspirational Focus</h4>
                <p className="text-sm text-muted-foreground">
                  Select where your organisation should ideally be positioned.
                </p>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}